<script setup lang="ts">
import type { LoginCredentials } from '@/types';
import { computed } from 'vue';
import { ref } from 'vue';


const model = ref<LoginCredentials>({username: '', password: ''});

const emitters = defineEmits<{
  doLogin: [credentials: LoginCredentials]
}>();

const validInput = computed(() => {
  let login = model.value.username;
  let password = model.value.password;
  if (login && password) {
    return login.length === 5 && password.length == 3;
  }
});

</script>
<template>
<div class="login">
    <div class="login-details">
      <label for="userPinId">
        ID
        <input v-model="model.username" id="userPinId" type="text" placeholder="00000" inputmode="numeric" maxlength="5" minlength="5"/>
      </label>
      <label for="pin">
        PIN
        <input v-model="model.password" id="pin" type="text" placeholder="000" inputmode="numeric" maxlength="3" minlength="3"/>
      </label>
    </div>
  <button class="ok" @click="$emit('doLogin', model)" :disabled="!validInput" :class="{'disabled': !validInput}">OK</button>
</div>


</template>
<style scoped>

button.disabled {
  background-color: gray;
  border-color: gainsboro;
}

input {
  width: 100%;
}

.login {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.login-details {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-top: 8px;
  gap: 8px;
}
</style>
